import { useEffect } from 'react';
const BRAND = '76UNBOXED';
// The tab's title while a page is shown, in the server's form: the page's name, then the brand. The
// server writes it on a full load; this keeps it right as visitors move between pages without one.
// Null leaves the title alone, as while a page is still loading what it is called.
export const useDocumentTitle = (title) => {
    useEffect(() => {
        if (title === null)
            return;
        const before = document.title;
        document.title = `${title} | ${BRAND}`;
        return () => { document.title = before; };
    }, [title]);
};
